import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type ValidationStepType, type CampaignValidationState } from "../../types/state";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";

const initialState: CampaignValidationState = {
  emailTemplateValidation: {
    initialized: false,
    isFormValid: undefined,
    activeErrors: {},
    resolved: true,
    touchedSnapshot: {},
  },
  landingPageValidation: {
    initialized: false,
    isFormValid: undefined,
    activeErrors: {},
    resolved: true,
    touchedSnapshot: {},
  },
  feedbackPageValidation: {
    initialized: false,
    isFormValid: undefined,
    activeErrors: {},
    resolved: true,
    touchedSnapshot: {},
  },
  errorMode: false,
};

const campaignValidationSlice = createSlice({
  name: `${ReducerNamespaceTypes.Library}/${ReducerEntityPrefixTypes.ThreatDefenceCampaigns}/campaignValidation`,
  initialState,
  reducers: {
    setIsValid(
      state: CampaignValidationState,
      action: PayloadAction<{ validationStep: ValidationStepType; isValid: boolean }>,
    ) {
      state[action.payload.validationStep].isFormValid = action.payload.isValid;
    },
    setErrorMode(state: CampaignValidationState, action: PayloadAction<boolean>) {
      state.errorMode = action.payload;
    },
    setResolved(
      state: CampaignValidationState,
      action: PayloadAction<{ validationStep: ValidationStepType; isResolved: boolean }>,
    ) {
      state[action.payload.validationStep].resolved = action.payload.isResolved;
    },
    setInitialized(
      state: CampaignValidationState,
      action: PayloadAction<{ validationStep: ValidationStepType; isInitialized: boolean }>,
    ) {
      state[action.payload.validationStep].initialized = action.payload.isInitialized;
    },
    setActiveErrors(
      state: CampaignValidationState,
      action: PayloadAction<{ validationStep: ValidationStepType; activeErrors: { [key: string]: string } }>,
    ) {
      state[action.payload.validationStep].activeErrors = action.payload.activeErrors;
    },
    setTouchedSnapshot(
      state: CampaignValidationState,
      action: PayloadAction<{ validationStep: ValidationStepType; touched: object }>,
    ) {
      state[action.payload.validationStep].touchedSnapshot = action.payload.touched;
    },
    reset: () => initialState,
    discard(state: CampaignValidationState) {
      state.errorMode = false;
    },
  },
});

export const {
  setIsValid,
  setErrorMode,
  setResolved,
  setInitialized,
  setActiveErrors,
  setTouchedSnapshot,
  reset,
  discard,
} = campaignValidationSlice.actions;

export default campaignValidationSlice.reducer;
